<template>
  <div
    class="min-h-screen flex flex-col justify-between items-center bg-surface-50 dark:bg-primary-900"
  >
    <LayoutHeader />
    <div class="flex flex-col flex-grow w-full max-w-[1440px] py-8">
      <LayoutContainer>
        <slot />
      </LayoutContainer>
    </div>
    <LayoutFooter
      minimal
      class="w-full"
    />
  </div>
</template>
